<template>
  <div>
    <HvhModal :value="true" :title="titleModal" :isLoading="isLoading" max-width="720" persistent @input="$emit('close')">
      <template v-slot>
        <v-form :class="{ readonly: readOnly }" @input="formValid = $event" ref="form">
          <div class="hvh-flex wrap">
            <v-text-field class="col-12 col-md-6" label="Customer #" :disabled="!!formData.id" v-model="formData.customerNumber" :rules="requiredRules" />
            <v-text-field class="col-12 col-md-6" label="Company/Facility" v-model="formData.facilityName" :rules="requiredRules" />
            <v-text-field class="col-12 col-md-6" label="Address" v-model="formData.address" :rules="requiredRules" />
            <v-text-field class="col-12 col-md-6" label="City" v-model="formData.city" :rules="requiredRules" />
            <v-text-field class="col-12 col-md-6" label="State (State Abbreviation only eg: NY)" v-model="formData.state"  maxlength="2" :rules="[...requiredRules, v => /^[A-Za-z]{2}$/.test(v) || 'State must be exactly 2 letters']" />
            <v-text-field class="col-12 col-md-6" label="ZIP" v-model="formData.zip" :rules="requiredRules" />
            <v-text-field class="col-12 col-md-4" label="Contact" v-model="formData.contact" :rules="requiredRules" />
            <v-text-field class="col-12 col-md-4" label="Email" v-model="formData.email" :rules="emailRules" />
            <v-text-field class="col-12 col-md-4" label="Phone" v-model="formData.contactNumber" :rules="requiredRules" />
            <div class="col-12 col-sm-4">
              <label for="toggle-switch" class="label">Subsidiary:</label>
              <input type="checkbox" id="toggle-switch" v-model="formData.isSubsidiary" @change="toggleSwitch" class="invisible" />
              <label for="toggle-switch" class="toggle"></label>
            </div>
            <v-select class="col-12 col-sm-8" v-model="formData.primaryFacility" item-text="facility" itemValue="id" :items="primaryCustomers" label="Select Primary" v-if="formData.isSubsidiary" :rules="requiredRules"></v-select>
            <template v-if="formData.isSubsidiary">
              <h2 class="col-12">RAM License</h2>
              <div class="hvh-flex wrap">
                <v-text-field class="col-12 col-md-4" label="LIC #" v-model="formData.ramLicenseId" :rules="requiredRules" />
                <v-text-field class="col-12 col-md-4" label="AMEND #" v-model="formData.amendId" :rules="requiredRules" />
                <div class="col-12 col-md-4 pt-0">
                  <HvhDatePicker label="EXP Date" v-model="formData.expDate" :rules="requiredRules" />
                </div>
              </div>
            </template>
          </div>

          <div class="hvh-flex align-center col-12 pb-0">
            <h2>Documents</h2>
            <v-icon class="ml-3" medium @click="documentForUpload = {}">mdi-plus-box-outline</v-icon>
          </div>
          <ITMDocuments class="col-12" :documents="formData.documents" @remove="removeDocument" />
        </v-form>
        <ITMUploadDocument :value="documentForUpload" :isLoading="isLoadingDocument" @input="addDocument" @close="documentForUpload = null" v-if="documentForUpload" />
      </template>
      <template v-slot:actions>
        <div class="hvh-flex space-between w-100">
          <div>
            <v-btn flat class="hvh-btn hvh-btn--secondary no-border" @click="showTokenModel = true" v-if="!readOnly && formData.id && getFlag('DAS-1310')">Token</v-btn>
          </div>
          <div>
            <template v-if="!readOnly">
              <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')">Cancel</v-btn>
              <v-btn flat class="hvh-btn hvh-btn--primary" :class="{ disabled: wasValidated && !formValid }" @click="saveData">Save</v-btn>
            </template>
            <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')" v-else>Close</v-btn>
          </div>
        </div>
      </template>
    </HvhModal>

    <ITMCustomerToken :customer="formData" @close="showTokenModel = false" v-if="showTokenModel" />
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import { errorDebug, toFormData } from '../../libraries/common';
import ITMDocuments from './ITMDocuments.vue';
import ITMUploadDocument from './ITMUploadDocument.vue';
import axios from '../../axios';
import ITMCustomerToken from './ITMCustomerToken.vue';
export default {
  components: { ITMDocuments, ITMUploadDocument, ITMCustomerToken },
  props: ['value', 'readOnly', 'isLoading'],
  data() {
    var requiredRules = [v => !!v || v === false || 'Field is required'];
    var emailRules = [v => /^[^\s@]+@\w+(\.\w+)+\w+$/.test(v) || 'Please enter a valid email address'];
    var formData = {
      documents: [],
    };
    return {
      primaryCustomers: [],
      isSubsidiary: false,
      formData: { ...formData, ...cloneDeep(this.value) },
      requiredRules,
      emailRules,
      numberRules: [
        ...requiredRules,
        v => (v > 0 && parseInt(v) == v) || 'You need to enter positive integer number',
      ],
      wasValidated: false,
      formValid: true,
      documentForUpload: null,
      isLoadingDocument: false,
      showTokenModel: false,
    };
  },
  methods: {
    toggleSwitch() {
      if (!this.formData.isSubsidiary) {
        this.formData.primaryFacility = null;
        this.formData.ramLicenseId = null,
          this.formData.amendId = null,
          this.formData.expDate = null
      }
    },
    saveData() {
      this.wasValidated = true;
      if (!this.$refs.form.validate()) return;
      this.$emit('input', this.formData);
    },
    getPrimaryCustomers() {
      axios.get(`/ITM/Customers/GetPrimaryCustomers`)
        .then(({ data }) => {
          this.primaryCustomers = data.map(obj => ({ id: obj.id, facility: obj.facilityName }));
        })
        .catch(errorDebug);
    },
    addDocument(event) {
      this.isLoadingDocument = true;
      axios.post(`/api/ITM/Documents`, toFormData(event))
        .then(({ data }) => {
          this.formData = {
            ...this.formData,
            documents: [
              ...this.formData.documents,
              data,
            ],
          };
          this.documentForUpload = null;
        })
        .catch(errorDebug)
        .then(() => this.isLoadingDocument = false);
    },
    removeDocument(item) {
      this.$confirm('Remove Document', `Are you sure you want to remove document ${item.fileName}?`)
        // .then(() => {
        //   this.isUpdating = true;
        //   axios.delete(`/api/ITM/Documents/${item.id}`)
        .then(() => this.formData = {
          ...this.formData,
          documents: this.formData.documents.filter(f => f.id !== item.id),
        })
        .catch(errorDebug);
    },
    textFnc(item) {
      return `${item.customerNumber} - ${item.facilityName} - ${item.city}/${item.state}/${item.zip} - ${item.email} - ${item.contactNumber}`;
    },
  },
  computed: {
    titleModal() {
      return !this.formData.id ? "Add Customer" : "Edit Customer";
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMAddCustomer'] = this;
    this.getPrimaryCustomers();
  },
}
</script>
<style scoped>
.toggle {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  background-color: #ccc;
  border-radius: 17px;
  transition: background-color 0.3s;
  margin-top: 8px;
}

.toggle::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: left 0.3s;
}

input:checked + .toggle {
  background-color: #666adf;
}

input:checked + .toggle::after {
  left: 18px;
}
.invisible {
  display: none;
}
.label {
  display: inline-block;
  padding-bottom: 15px;
  margin-right: 10px;
  vertical-align: middle;
}
.no-border {
  border: 0px !important;
  box-shadow: none !important;
}
</style>